
import { useEffect, useState } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'
import { PillerELDDLAPI, PoleELDDLAPI } from '../../Redux/DDLSlice'

export const PoleDDL = (props) => {

    const { PillerID,PoleID, setPoleID, LocationName, WardName, APIFlag, IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()


    useEffect(() => {
        const data = {
            M_ELEC_LocationID: LocationName?.ID,
            M_ELEC_PillerID: PillerID?.ID,
            Flag: APIFlag,
            M_WardID: WardName?.ID,
            M_UserID: UserID,
            token: token
        }
        dispatch(PoleELDDLAPI({ data }))
    }, [WardName?.ID, LocationName?.ID, IsPost, PillerID?.ID])

    const { PoleData } = useSelector(state => state.PoleELDDLData)

    useEffect(() => {
        console.log('PoleData', PoleData)
        handlePillerDDL()
    }, [PoleData])

    const handlePillerDDL = () => {
        if (PoleData && PoleData.table && PoleData.table.length > 0) {
            let list = PoleData.table.map((item, index) => ({
                value: item.m_eleC_PoleID,
                label: item.poleNumber,
            }))
            setPoleID({
                DDL: list,
                // ID: Flag === 'Update' ? rowData.m_WorkID : 0,
                // Label: Flag === 'Update' ? rowData.projectWorkname : "Select...",
                ID: 0,
                Label: "Select...",
            })
        }
        else {
            setPoleID({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label for="" className=""><b>Pole Count</b></label>

            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width2"
                isSearchable
                maxMenuHeight={115}
                value={{ value: PoleID.ID, label: PoleID.Label }}
                onChange={(e) => {
                    e ?
                        setPoleID({ ...PoleID, ID: e.value, Label: e.label })
                        :
                        setPoleID({ ...PoleID, ID: 0, Label: "Select..." })
                }}
                options={PoleID.DDL}
            />
        </div>
    )
}